import React from 'react';
import NotificationsView from './NotificationsView';

const NotificationsPage: React.FC = () => <NotificationsView />;

export default NotificationsPage;
